// extracted by mini-css-extract-plugin
export default {"contentWrapper":"CollapsibleLog_contentWrapper__7ZGk7","collapseButton":"CollapsibleLog_collapseButton__SfwYK"};